import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { JobFormData } from "../types/jobTypes";
import { useTranslation } from "react-i18next";

interface AdditionalInfoTabProps {
  jobData: JobFormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, field: keyof JobFormData) => void;
}

export const AdditionalInfoTab = ({
  jobData,
  handleInputChange,
}: AdditionalInfoTabProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4 min-h-[500px] pb-32">
      <div>
        <Label htmlFor="applicationDeadline" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.applicationDeadline")}
        </Label>
        <Input
          id="applicationDeadline"
          type="date"
          value={jobData.applicationDeadline}
          onChange={(e) => handleInputChange(e, "applicationDeadline")}
        />
      </div>
      
      <div>
        <Label htmlFor="jobPostingDate" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.jobPostingDate")}
        </Label>
        <Input
          id="jobPostingDate"
          type="date"
          value={jobData.jobPostingDate}
          onChange={(e) => handleInputChange(e, "jobPostingDate")}
        />
      </div>
      
      <div>
        <Label htmlFor="source" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.source")}
        </Label>
        <Input
          id="source"
          type="text"
          value={jobData.source}
          onChange={(e) => handleInputChange(e, "source")}
          placeholder={t("jobs.formWizard.sourcePlaceholder")}
        />
      </div>
      
      <div>
        <Label htmlFor="assignedRecruiter" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.assignedRecruiter")}
        </Label>
        <Input
          id="assignedRecruiter"
          type="text"
          value={jobData.assignedRecruiter}
          onChange={(e) => handleInputChange(e, "assignedRecruiter")}
        />
      </div>
      
      <div>
        <Label htmlFor="notes" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.additionalNotes")}
        </Label>
        <Textarea
          id="notes"
          rows={4}
          value={jobData.notes || ""}
          onChange={(e) => handleInputChange(e, "notes")}
          placeholder={t("jobs.formWizard.additionalNotesPlaceholder")}
        />
      </div>
    </div>
  );
};
